<template>
	<div id="wrap">
		<div class="title1">短信服务 <img class="sanjiao" src="/static/qmsj/img/duanxin/xiangyou.png" alt=""> 充值记录
			<a>
				<p @click="jump_m('duanxin')" class="returnBtn">返回</p>
			</a>
			<a>
				<p @click="jump_m('chongzhi')" class="returnBtn" style="margin-right: 30px">充值</p>
			</a>
		</div>
		<div class="count_nei1">
			<div class="cont_title">充值记录</div>
		</div>

		<div style="width: 100%;padding-left: 45px;margin-top: 20px">
			<el-date-picker
		      v-model="start_time"
		      type="date"
		      style="width: 160px;float: left;"
		      value-format="yyyy-MM-dd"
		      size="small"
		      placeholder="选择日期">
		    </el-date-picker>
			<el-date-picker
		      v-model="end_time"
		      type="date"
		      style="width: 160px;float: left;margin:0 10px 0 20px;"
		      value-format="yyyy-MM-dd"
		      size="small"
		      placeholder="选择日期">
		    </el-date-picker>
			<input @click="get_list" src="/static/qmsj/img/duanxin/suosou.png" class="shijian3" style="width: 30px;height:30px;vertical-align:middle;padding-left: 0;border: none;" type="image">
			<!-- <div class="col-md-2">
        <p class="chzongji1">总计：条</p>
    </div>
    <div class="col-md-2">
        <p class="chzongji2">元</p>
    </div> -->
		</div>
		<div style="width: 100%;height: 10px;clear: both"></div>
		<div class="chongzhitable">
			<table class="table table-striped table-hover">
				<thead>
					<tr style="height: 42px;line-height: 42px;font-size: 14px;background:#f1eff2;padding: 0 ">
						<th style="padding-bottom:10px;text-align: center;width: 40%;">时间</th>
						<th style="padding-bottom:10px;text-align: center">金额</th>
						<th style="padding-bottom:10px;text-align: center">条数</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in database">
						<td style="padding-bottom:10px;text-align: center">{{item.create_time}}</td>
						<td style="padding-bottom:10px;text-align: center">{{item.f_jine}}</td>
						<td style="padding-bottom:10px;text-align: center">{{item.dx_shu}}</td>
					</tr>
				</tbody>
				<tfoot>
					<tr>
						<td>合计</td>
						<td>{{totalNum.money}}</td>
						<td>{{totalNum.num}}</td>
					</tr>
				</tfoot>
			</table>
			<div style="padding-top:30px;float: right;">
				<el-pagination
			      @current-change="handleCurrentChange"
			      :current-page.sync="currentPage"
			      :page-size="10"
			      background
			      layout="prev, pager, next, jumper"
			      :total="page_list.count">
			    </el-pagination>
			</div>

		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				token:'',
				currentPage: 1,//当前页
				database:[],//数据
				totalNum:'',//合计
				page_list:'',//分页数据
				start_time:'',//开始日期
				end_time:'',//结束日期
			};
		},
		created(){
			this.token = this.$cookies.get('token');

			this.get_list()
		},
		methods: {
			//表格数据
			get_list(){
				let that = this
		 	  	$.ajax({
				   url: process.env.apiUrl + 'saas/dx/dxczjl',
				   type: 'post',
				   data:{
				  	  token:that.token,
				  	  page:that.currentPage,
				  	  time_start:that.start_time,
				  	  time_end:that.end_time,
				    },
				    success: function (data, status) {
				        if(data.status == 1){
				        	that.database = data.data.fei
				        	that.totalNum = data.data.zong
				        	that.page_list = data.map
				        }else if(data.status == 2){
                            that.database= ''
                            that.totalNum = ''
                            that.page_list = ''
                            that.$message.error({
                                message:'暂无数据'
                            })
                        }
		 			},
				    fail: function (err, status) {
				        console.log(err)
				    }
				})
			},
			//跳转页面
			jump_m(u){
				this.$router.push({path:u})
			},
			//分页
			handleCurrentChange(val) {
		        this.currentPage = val
		        this.get_list()
		    }

		}

	}
</script>

<style scoped>
	@import url("../../../static/qmsj/css/duanxin/chushiyangsh.css");
	@import url("../../../static/qmsj/css/duanxin/fasongjilu.css");
	@import url("../../../static/qmsj/css/duanxin/bootstrap-table.css");
	@import url("../../../static/qmsj/css/duanxin/bootstrap-datetimepicker.min.css");

	.body {
		padding-left: 45px;
		padding-right: 45px;
	}

	ul {
		list-style: none;
	}

	.cont_title {
		padding-left: 7px;
		height: 24px;
		line-height: 24px;
		font-size: 14px;
		border-left: 6px solid #8CBB77;
		margin-top: 14px;
		margin-bottom: 10px;
	}

	.returnBtn {
		width: 80px;
		height: 24px;
		line-height: 24px;
		color: #fff;
		background: #8CBB77;
		border-radius: 12px;
		text-align: center;
		float: right;
		font-size: 12px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/duanxin/chongzhijl.vue